const removeValueIsEmpty = (data = {}) => {
  let _data = (data && typeof data === 'object') ? data : {};
  return Object.fromEntries(Object.entries(_data).filter(([_, v]) => _ && v != null)); // null || undefined
}

const removeValueIsNull = (data = {}) => {
  let _data = (data && typeof data === 'object') ? data : {};
  return Object.fromEntries(Object.entries(_data).filter(([_, v]) => _ && v !== null)); // null
}

const removeValueIsUndefined = (data = {}) => {
  let _data = (data && typeof data === 'object') ? data : {};
  return Object.fromEntries(Object.entries(_data).filter(([_, v]) => _ && v !== undefined)); // undefined
}

const replaceDeep = (current, update = {}) => {
  if (update === undefined || update === null) update = {};
  Object.keys(update).forEach(function(key) {
    if (Object.prototype.hasOwnProperty.call(current, key)) {
      if (
        typeof current[key] === 'object' && 
        typeof update[key] === 'object' && 
        !(current[key] instanceof Array)
      ) {
        replaceDeep(current[key], update[key]);
      } else {
        current[key] = update[key];
      }
    }
  });
  return current;
}

const mergeDeep = (current, update = {}) => {
  if (update === undefined || update === null) update = {};
  Object.keys(update).forEach(function(key) {
    if (
      typeof current[key] === 'object' && 
      typeof update[key] === 'object' && 
      !(current[key] instanceof Array)
    ) {
      mergeDeep(current[key], update[key]);
    } else {
      current[key] = update[key];
    }
  });
  return current;
}

const chunkObject = (obj, chunkSize = 20) => {
  const entries = Object.entries(obj);
  const chunks = [];

  for (let i = 0; i < entries.length; i += chunkSize) {
    const slice = entries.slice(i, i + chunkSize);
    chunks.push(Object.fromEntries(slice));
  }

  return chunks;
}

export {
  replaceDeep,
  mergeDeep,
  removeValueIsEmpty,
  removeValueIsNull,
  removeValueIsUndefined,
  chunkObject,
}
export default {
  replaceDeep,
  mergeDeep,
  removeValueIsEmpty,
  removeValueIsNull,
  removeValueIsUndefined,
  chunkObject,
}